module.exports = __webpack_public_path__ + "img/fig38.0da6da8f.jpg";